import { FormattedMessage } from '@subaio/components'

import { HeaderIconError } from 'components/Icons'
import { ContentCenter, HeaderIconWrapper, Page, SecondaryText, Title } from 'components/Layout'

export const Error = () => (
	<Page>
		<ContentCenter>
			<HeaderIconWrapper>
				<HeaderIconError />
			</HeaderIconWrapper>
			<Title>
				<FormattedMessage id='error.message.title' defaultMessage='Something went wrong' />
			</Title>
			<SecondaryText>
				<FormattedMessage
					id='error.message.text'
					defaultMessage='Something went wrong while retrieving the data. Please try again.'
				/>
			</SecondaryText>
		</ContentCenter>
	</Page>
)
